module.exports = __webpack_public_path__ + "officialStatic/img/trusteeshipBg.a34dc79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeshipBg.png
// module id = zE3p
// module chunks = 0